import { TRIGGER_SEND_MONEY_BANK_LIST_API, TRIGGER_SEND_MONEY_BANK_LIST_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchSendMoneyBankListApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_SEND_MONEY_BANK_LIST_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchSendMoneyBankListApiCallSuccess(data) {
	return {
		type: TRIGGER_SEND_MONEY_BANK_LIST_API_SUCCESS,
		data,
	};
}
